import { useState } from 'react'
// import type { ReactEventHandler} from 'react'

export default function useImageFailedHandle() {
  const [imageErrored, setImageErrored] = useState(false)
  const handleImageError = () => setImageErrored(true)

  return [imageErrored, handleImageError] as const
}
